import { IPersonalConsultation } from "../../Interfaces/Appointments";
import { postRequest } from "./Data";
import { InputText } from "../../Components/Form/Input";
import { Toast } from "../../Components/Dialog/Toast";
import LoaderOverlay from "../LoaderOverlay";
import Confetti from "./Confetti";
import { RadioGroup } from "../../Components/Form/RadioGroup";
import { CONFETTI_OPTIONS, PERSONAL_CONSULTATION } from "./Constants";

class PersonalConsultation {
    private readonly form: HTMLFormElement;
    private readonly store: string;
    private readonly locationInput: InputText;
    private readonly typeOfContactInput: RadioGroup;
    private readonly loader = new LoaderOverlay();
    private readonly confetti = new Confetti(CONFETTI_OPTIONS.count, CONFETTI_OPTIONS.defaults);

    constructor(form: HTMLFormElement) {
        this.form = form;
        this.store = this.getFormData().store;
        this.locationInput = this.form.querySelector(PERSONAL_CONSULTATION.SELECTORS.location);
        this.typeOfContactInput = this.form.querySelector(PERSONAL_CONSULTATION.SELECTORS.typeOfContact);

        this.handleLocationChange().initListeners();
    }

    initListeners() {
        this.form.addEventListener("submit", this.submit.bind(this));
        this.locationInput.addEventListener("change", this.handleLocationChange.bind(this));

        return this;
    }

    handleLocationChange() {
        if (this.store == "ebike") return this;
        const webOption = this.typeOfContactInput.querySelector('[data-value="Per Webkonferenz"]');

        webOption.classList.toggle("hide-me", this.locationInput.value !== "filderstadt");

        return this;
    }

    async submit(e: Event) {
        e.preventDefault();
        this.loader.render();
        try {
            let key: "lim" | "ebike";
            if (this.store == "ebike") {
                key = "ebike";
            } else {
                key = "lim";
            }
            await postRequest(this.getFormData(), PERSONAL_CONSULTATION.REQUEST_TYPES[key]);
            this.loader.destroy();

            this.confetti.render();

            new Toast({
                title: window.SuccessMessages.purchaseRequest.success,
                type: Toast.TYPE_SUCCESS
            })?.render();

            this.form.reset();
        } catch (e) {
            console.error(e);
            this.loader.destroy();
            new Toast({
                title: window.SuccessMessages.purchaseRequest.error,
                type: Toast.TYPE_ERROR
            })?.render();
        }
    }

    private getFormData(): IPersonalConsultation {
        const formData = new FormData(this.form);
        const data: IPersonalConsultation = {
            first_name: formData.get("first_name") as string,
            last_name: formData.get("last_name") as string,
            mail: formData.get("mail") as string,
            accept_terms_and_conditions: formData.get("accept_terms_and_conditions") === "1",
            store: formData.get("store") as string,
            locale: formData.get("locale") as string
        };
        if (formData.get("tel")) {
            data.tel = formData.get("tel") as string;
        }
        if (formData.get("newsletter")) {
            data.newsletter = formData.get("newsletter") === "1";
        }
        if (formData.get("purpose")) {
            data.purpose = formData.get("purpose") as string;
        }
        if (formData.get("brand")) {
            data.brand = formData.get("brand") as string;
        }
        if (formData.get("location")) {
            data.location = formData.get("location") as string;
        }
        if (formData.get("type_of_contact")) {
            data.type_of_contact = formData.get("type_of_contact") as string;
        }
        if (formData.get("date")) {
            data.date = formData.get("date") as string;
        }
        if (formData.get("time")) {
            data.time = formData.get("time") as string;
        }
        return data;
    }

    set location(v) {
        this.locationInput.value = v;
    }

    get location() {
        return this.locationInput.value;
    }
}

export default PersonalConsultation;

const form = document.getElementById("personal-consultation-form") as HTMLFormElement;
if (form) {
    new PersonalConsultation(form);
}
